import React from 'react';
import AgGridWrapper from 'common/table/agGrid/AgGridWrapper';

export type GridOpts = {
  GridComponent?: React.ComponentType;
  gridName?: string;
};

type Props = {
  gridOpts: GridOpts;
  originalTable: React.ReactNode;
};

const ClearingAccountsWrapper = ({ gridOpts = {}, originalTable }: Props) => {
  const { GridComponent, gridName } = gridOpts;
  if (GridComponent && originalTable && gridName) {
    return (
      <AgGridWrapper
        gridName={gridName}
        agGridComponent={<GridComponent />}
        reactTableComponent={originalTable}
      />
    );
  }

  return originalTable;
};

export default ClearingAccountsWrapper;
